import React from 'react';

const Reports = () => {
  return (
    <div className="page">
      <h1>Reports</h1>
      <p>View and generate system reports here.</p>
      <div style={{ padding: '20px', background: 'white', borderRadius: '8px', marginTop: '20px' }}>
        <p>This feature is coming soon...</p>
      </div>
    </div>
  );
};

export default Reports;
